import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const A = (props) => <Text>{props.children}</Text>;

A.propTypes = {
  children: PropTypes.node.isRequired,
};

export default A;

// STYLED COMPONENT
// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

const Text = styled.span`
  font-size: 12px;
  color: #ff0000;
  text-align: center;
  display: block;
  max-width: 300px;
  margin-top: 5px;
`;
